import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconHelpOutline } from '@travel-frontend/icons';
import { Container } from '../../primitives/HelpTooltip/components/Container.js';
import { Tooltip } from '../../primitives/Tooltip/index.js';
export const HelpTooltip = /*#__PURE__*/_styled(({
  // <Tooltip /> props
  open,
  initialOpen,
  placement,
  strategy,
  interactive = true,
  collisionDetection,
  title,
  content,
  width,
  escapeContent = true,
  tooltipText,
  ...restProps
}) => {
  // Needs to be kept in sync with <Tooltip /> props!
  const tooltipProps = {
    open,
    initialOpen,
    placement,
    strategy,
    interactive,
    collisionDetection,
    title,
    // content,
    width,
    tooltipElement: 'IconHelpOutline',
    tooltipText: tooltipText || (
    // Your default text for React components
    typeof content === 'string' ? content.slice(0, 100) : undefined)
  };
  return _jsx(Tooltip, {
    ...tooltipProps,
    content: typeof content === 'string' && !escapeContent ? _jsx("div", {
      dangerouslySetInnerHTML: {
        __html: content
      }
    }) : content,
    children: _jsx(Container, {
      tabIndex: 0,
      ...restProps,
      children: _jsx(IconHelpOutline, {
        fontScale: "small"
      })
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1v0h7sp0"
} : {
  target: "e1v0h7sp0",
  label: "HelpTooltip"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkhlbHBUb29sdGlwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdCRyIsImZpbGUiOiJIZWxwVG9vbHRpcC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBJY29uSGVscE91dGxpbmUgfSBmcm9tICdAdHJhdmVsLWZyb250ZW5kL2ljb25zJztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvSGVscFRvb2x0aXAvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgVG9vbHRpcCB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvVG9vbHRpcC9pbmRleC5qcyc7XG5leHBvcnQgY29uc3QgSGVscFRvb2x0aXAgPSBzdHlsZWQoKHsgXG4vLyA8VG9vbHRpcCAvPiBwcm9wc1xub3BlbiwgaW5pdGlhbE9wZW4sIHBsYWNlbWVudCwgc3RyYXRlZ3ksIGludGVyYWN0aXZlID0gdHJ1ZSwgY29sbGlzaW9uRGV0ZWN0aW9uLCB0aXRsZSwgY29udGVudCwgd2lkdGgsIGVzY2FwZUNvbnRlbnQgPSB0cnVlLCB0b29sdGlwVGV4dCwgLi4ucmVzdFByb3BzIH0pID0+IHtcbiAgICAvLyBOZWVkcyB0byBiZSBrZXB0IGluIHN5bmMgd2l0aCA8VG9vbHRpcCAvPiBwcm9wcyFcbiAgICBjb25zdCB0b29sdGlwUHJvcHMgPSB7XG4gICAgICAgIG9wZW4sXG4gICAgICAgIGluaXRpYWxPcGVuLFxuICAgICAgICBwbGFjZW1lbnQsXG4gICAgICAgIHN0cmF0ZWd5LFxuICAgICAgICBpbnRlcmFjdGl2ZSxcbiAgICAgICAgY29sbGlzaW9uRGV0ZWN0aW9uLFxuICAgICAgICB0aXRsZSxcbiAgICAgICAgLy8gY29udGVudCxcbiAgICAgICAgd2lkdGgsXG4gICAgICAgIHRvb2x0aXBFbGVtZW50OiAnSWNvbkhlbHBPdXRsaW5lJyxcbiAgICAgICAgdG9vbHRpcFRleHQ6IHRvb2x0aXBUZXh0IHx8IC8vIFlvdXIgZGVmYXVsdCB0ZXh0IGZvciBSZWFjdCBjb21wb25lbnRzXG4gICAgICAgICAgICAodHlwZW9mIGNvbnRlbnQgPT09ICdzdHJpbmcnID8gY29udGVudC5zbGljZSgwLCAxMDApIDogdW5kZWZpbmVkKSxcbiAgICB9O1xuICAgIHJldHVybiAoX2pzeChUb29sdGlwLCB7IC4uLnRvb2x0aXBQcm9wcywgY29udGVudDogdHlwZW9mIGNvbnRlbnQgPT09ICdzdHJpbmcnICYmICFlc2NhcGVDb250ZW50ID8gKF9qc3goXCJkaXZcIiwgeyBkYW5nZXJvdXNseVNldElubmVySFRNTDogeyBfX2h0bWw6IGNvbnRlbnQgfSB9KSkgOiAoY29udGVudCksIGNoaWxkcmVuOiBfanN4KENvbnRhaW5lciwgeyB0YWJJbmRleDogMCwgLi4ucmVzdFByb3BzLCBjaGlsZHJlbjogX2pzeChJY29uSGVscE91dGxpbmUsIHsgZm9udFNjYWxlOiBcInNtYWxsXCIgfSkgfSkgfSkpO1xufSkgYGA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1IZWxwVG9vbHRpcC5qcy5tYXAiXX0= */");